import dayjs from 'dayjs';

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

export const TimeStatsForOperationsConfig = {
	id: DYNAMICLISTS.TIME_STATS_FOR_OPERATION,
	columns: [
		{
			Header: 'ID',
			accessor: 'ID',
			filterType: FilterType.number,
			width: 70,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'orderID',
			accessor: 'orderID',
			filterType: FilterType.number
		},

		{
			Header: 'shipmentNumber',
			accessor: 'shipmentNumber',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'companyID',
			accessor: 'companyId',
			filterType: FilterType.number,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'clientName',
			accessor: 'clientName',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'clientID',
			accessor: 'clientID',
			filterType: FilterType.number,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'createdDate',
			accessor: 'createdDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME,
			customFilterOptions: [FilterAction.between, FilterAction.on],
			showOnMobile: true
		},
		{
			Header: 'createdBy',
			accessor: 'createdBy',
			filterType: FilterType.string,
			show: false,
			showCopyButton: true
		},

		{ Header: 'modifiedBy', accessor: 'modifiedBy', filterType: FilterType.string, show: false },
		{
			Header: 'modifiedDate',
			accessor: 'modifiedDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},

		{
			Header: 'deliverySLA',
			accessor: 'deliverySLA',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'preperationSLA',
			accessor: 'preperationSLA',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'pickupSLA',
			accessor: 'pickupSLA',
			filterType: FilterType.string,
			show: false
		},

		{
			Header: 'lastStatusUpdate',
			accessor: 'lastStatusUpdate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'assignedDate',
			accessor: 'assignedDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'branchName',
			accessor: 'branchName',
			filterType: FilterType.string,
			show: false
		},

		{
			Header: 'branchID',
			accessor: 'branchID',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'warehouseName',
			accessor: 'warehouseName',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'warehouseID',
			accessor: 'warehouseID',
			filterType: FilterType.string,
			show: false
		},

		{
			Header: 'originCountry',
			accessor: 'originCountry',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.COUNTRIES,
			filterPrefix: 'country.',
			renderCell: ListComponents.COUNTRY,
			width: 100,
			show: false
		},
		{
			Header: 'originCity',
			accessor: 'originCity',
			filterType: FilterType.string
		},
		{
			Header: 'destinationCountry',
			accessor: 'destinationCountry',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.COUNTRIES,
			filterPrefix: 'country.',
			renderCell: ListComponents.COUNTRY,
			width: 100,
			show: false
		},
		{
			Header: 'destinationCity',
			accessor: 'destinationCity',
			filterType: FilterType.string
		},
		{
			Header: 'agreementType',
			accessor: 'agreementType',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.SHIPPING_PRICE_AGREEMENT_TYPE
		},
		{
			Header: 'deliveryCompanyID',
			accessor: 'deliveryCompanyID',
			filterType: FilterType.number,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'DCSettingName',
			accessor: 'DCSettingName',
			filterType: FilterType.string
		},
		{
			Header: 'DCSettingID',
			accessor: 'DCSettingID',
			filterType: FilterType.number,
			show: false
		},
		{
			Header: 'preparationTime',
			accessor: 'preparationTime',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'pickupTime',
			accessor: 'pickupTime',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'pickupCutoffTime',
			accessor: 'pickupCutoffTime',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'totalDeliveryTime',
			accessor: 'totalDeliveryTime',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'transferDuration',
			accessor: 'transferDuration',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'secondAttemptDate',
			accessor: 'secondAttemptDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'lastAttemptDate',
			accessor: 'lastAttemptDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},

		{
			Header: 'lossDate',
			accessor: 'lossDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'driverId',
			accessor: 'driverId',
			filterType: FilterType.number,
			show: false
		},
		{
			Header: 'driverName',
			accessor: 'driverName',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'driverPhone',
			accessor: 'driverPhone',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'deliverySlotDate',
			accessor: 'deliverySlotDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'deliverySlotFrom',
			accessor: 'deliverySlotFrom',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'deliverySlotTo',
			accessor: 'deliverySlotTo',
			filterType: FilterType.string,
			show: false
		},

		{
			Header: 'trackingURL',
			accessor: 'trackingURL',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'reverseShipment',
			accessor: 'isReverseShipment',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.YES_NO,
			renderCell: ListComponents.STATUS,
			show: false
		},
		{
			Header: 'isCompleted',
			accessor: 'isCompleted',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'shipmentCreatedDate',
			accessor: 'shipmentCreatedDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			filterRemovable: false
		},

		{
			Header: 'newOrderDate',
			accessor: 'newOrderDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'firstPickupAttemptDate',
			accessor: 'firstPickupAttemptDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'shipmentCanceledDate',
			accessor: 'shipmentCanceledDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},

		{
			Header: 'pickupDate',
			accessor: 'pickupDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'undeliveredAttemptDate',
			accessor: 'undeliveredAttemptDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'deliveryDate',
			accessor: 'deliveryDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'returnDate',
			accessor: 'returnDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},

		{
			Header: 'canceledDate',
			accessor: 'canceledDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},

		{
			Header: 'undeliveredAttemptCnt',
			accessor: 'undeliveredAttemptCnt',
			filterType: FilterType.number,
			show: false
		},
		{
			Header: 'status',
			accessor: 'status',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.ALL_STATUSES,
			renderCell: ListComponents.SHIPMENT_STATUS,
			renderCellProps: {
				ID: 'orderID',
				orderID: 'orderIncrementId'
			},
			showOnMobile: true
		},
		{
			Header: 'ignoreStat',
			accessor: 'ignoreStat',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'pickUpSLATime',
			accessor: 'pickUpSLATime',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'deliverySLATime',
			accessor: 'deliverySLATime',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'pickingType',
			accessor: 'pickingType',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.NEW_PICKUP_TYPES
		},
		{
			Header: 'deliveryType',
			accessor: 'deliveryType',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.NEW_DELIVERY_TYPES
		},
		{
			Header: 'estimatedTransitDate',
			accessor: 'estimatedTransitDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'orderIncrementId',
			accessor: 'orderIncrementId',
			filterType: FilterType.string
		},
		{
			Header: 'returnCreateDate',
			accessor: 'returnCreateDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'orderCancelReason',
			accessor: 'orderCancelReason',
			filterType: FilterType.string
		},
		{
			Header: 'pickupId',
			accessor: 'pickupId',
			filterType: FilterType.string,
			showCopyButton: true,
			showOnMobile: true
		},
		{
			Header: 'originDistrict',
			accessor: 'originDistrict',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'destinationDistrict',
			accessor: 'destinationDistrict',
			filterType: FilterType.string,
			showOnMobile: true
		}
	],
	fetchUrl: REPORT.LIST.GET_TIME_STAT_FOR_OPERATION_LIST,
	exportName: 'timeStatsForOperationList'
};

const TimeStatsForOperationList = () => {
	const { state } = useLocation();

	const defaultFilters = useMemo(() => {
		if (state?.data?.date) {
			return [
				{
					column: TimeStatsForOperationsConfig.columns.find((c) => c.accessor === 'shipmentCreatedDate'),
					action: FilterAction.between,
					value: state.data.date
				}
			];
		} else {
			return [
				{
					column: TimeStatsForOperationsConfig.columns.find((c) => c.accessor === 'shipmentCreatedDate'),
					action: FilterAction.between,
					value: {
						start: dayjs().startOf('day').toISOString(),
						end: dayjs().endOf('day').toISOString()
					}
				}
			];
		}
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="timeStats"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.ORDER_REPORTS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList
				{...TimeStatsForOperationsConfig}
				defaultFilters={defaultFilters}
				actionObjectType={ACTION_OBJECT_TYPES.ORDER}
			/>
		</div>
	);
};

export default TimeStatsForOperationList;
